import { Component, EventEmitter, Inject, Input, Output } from "@angular/core";
import { ExerciceRow } from "../../providers/exercices-provider";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NgForOf, NgIf, NgOptimizedImage, NgStyle } from "@angular/common";
import { ExerciceCategoryThumbnailComponent } from "../exercice-category-thumbnail/exercice-category-thumbnail";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogModule
} from "@angular/material/dialog";
import { Organization } from "../../../common/models/organization";
import {
  SessionExerciceDurationComponent
} from "../../../sessions/components/session-exercice-duration/session-exercice-duration";
import {
  SessionExerciceRepeatComponent
} from "../../../sessions/components/session-exercice-repeat/session-exercice-repeat";
import { Exercice } from "../../../common/models/exercice";
import { SessionItemRow, SessionItemsProvider } from "../../../sessions/providers/sessionItems-provider";
import { MatTooltip } from "@angular/material/tooltip";
import { ShareComponent } from "../../../chat/share/share.component";
import { ExercicesFormComponent } from "../form/form";
import { Subscription } from "rxjs";
import { ExercicesVideoButtonComponent } from "../video-button/video-button";
import { FilesVideoPlayerDialogComponent } from "../../../files/components/video-player-dialog/video-player-dialog";
import { ConfigProvider } from "../../../config-provider.service";


@Component({
  selector: 'exercice-list-show-dialog',
  templateUrl: './exercice-list-show-dialog.html',
  styleUrls: ['./exercice-list-show-dialog.scss'],
  standalone: true,
    imports: [
        MatCardModule,
        TranslateModule,
        NgIf,
        NgForOf,
        ExerciceCategoryThumbnailComponent,
        NgOptimizedImage,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        NgStyle,
        MatDialogModule,
        SessionExerciceDurationComponent,
        SessionExerciceRepeatComponent,
        MatTooltip,
        ShareComponent,
        ExercicesVideoButtonComponent,
    ],
})
export class ExerciceListShowDialogComponent {
  protected readonly Exercice = Exercice;

  public exerciceRow: ExerciceRow;
  public organization: Organization;
  public isEditOpened: boolean = false;
  public isVideoOpened: boolean = false;

  constructor(
    private sessionItemsProvider: SessionItemsProvider,
    private dialog: MatDialog,
    protected conf: ConfigProvider,
    private translater: TranslateService,
    @Inject(MAT_DIALOG_DATA) private _data :any
  ) {
    if (!this._data) {
      throw new Error('No data provided');
    }
    if (!this._data.exerciceRow) {
      throw new Error('No exerciceRow provided');
    }
    if (!this._data.organization) {
      throw new Error('No organization provided');
    }

    this.exerciceRow = this._data.exerciceRow;
    this.organization = this._data.organization;
  }


  public onModifyExerciceClicked(): void {
    this.isEditOpened = true;
    const dialogRef: any = this.dialog.open(ExercicesFormComponent, {
      data: {
        organization: this.organization,
        exerciseRow: this.exerciceRow,
        formTitle: 'Exercise_edition',
        confirmButtonTitle: this.translater.instant('Save')
      }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.exerciceRow = result;
      }
      this.isEditOpened = false;
    });
  }


  public onPlayVideo() {
    if (this.exerciceRow.exercice.video_path && this.organization) {
      this.isVideoOpened = true;
      const dialogRef: any = this.dialog.open(FilesVideoPlayerDialogComponent, {
        data: {
          title: this.exerciceRow.exercice.name,
          src: this.conf.storageRootUrl + this.exerciceRow.exercice.video_path,
        }
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        this.isVideoOpened = false;
      });
    } else if (this.exerciceRow.exercice.video_url) {
      window.open(this.exerciceRow.exercice.video_url, '_blank');
    }
  }

  public getEmptyItemExercice(): SessionItemRow {
    return this.sessionItemsProvider.getEmptyItemExercice(this.exerciceRow);
  }

  public getAsSharableType(data: any) {
    return new Exercice({
      id: data.id,
      name: data.name,
    })
  }


}
